module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {


		items.forEach(function(item, i) {
;
__p += '\n			<a id="' +
((__t = (item.BX_ID)) == null ? '' : __t) +
'%>" href="' +
((__t = (item.DETAIL_PAGE_URL)) == null ? '' : __t) +
'" class="vacancies__el">\n				<span class="vacancies__title">' +
((__t = (item.NAME)) == null ? '' : __t) +
'</span>\n				<div class="vacancies__info">\n					<span class="vacancies__department">' +
((__t = (item.DEPARTMENT)) == null ? '' : __t) +
'</span>\n					<time class="vacancies__date" pubdate datetime="' +
((__t = (item.PUB_TIME_ATR)) == null ? '' : __t) +
'">' +
((__t = (item.ACTIVE_FROM)) == null ? '' : __t) +
'</time>\n				</div>\n			</a>\n';

		})
;
__p += '\n';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./frontend/components/vacancies/vacancies.ejs
// module id = 206
// module chunks = 0